var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pure-item",style:({
    backgroundColor: _vm.data
  }),attrs:{"data-color":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }